<style>
.emailLog td {
  border-top-width: 0px;
  padding: 0px;
}
.emailLog #templatePreheader {
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
<template>
  <v-modal
    v-if="show"
    :show="show"
    @update:show="$emit('update:show', $event)"
    :isTableModal="true"
  >
    <h4 slot="header" class="title title-up">E-Mail Nachricht</h4>
    <div class="card-body">
      <span class="emailLog" v-html="$attrs.email"></span>
    </div>
  </v-modal>
</template>

<script lang="babel">
import { Modal } from "src/components/UIComponents";

export default {
  components: {
    'v-modal': Modal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
};
</script>
